import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-maintenance-modal',
  imports: [BaseModalComponent, TranslocoDirective],
  templateUrl: './maintenance-modal.component.html',
  styleUrl: './maintenance-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenanceModalComponent {
  title = input<string>('Maintenance');

  message = input<string>('The app is currently under maintenance. Please try again later.');
}
